import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/vercel/path0/app/[locale]/(root)/contact/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactHero"] */ "/vercel/path0/app/[locale]/(root)/contact/components/ContactHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactInfo"] */ "/vercel/path0/app/[locale]/(root)/contact/components/ContactInfo.tsx");
